import { useEffect, useState } from "react";
import client from "../../../api/camasirhaneApi";

export function usePeriodStatus(year, month) {
  const [isClosed, setIsClosed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    client.get("/periods/", { params: { year, month } })
      .then((res) => {
        const match = res.data.find((p) => p.year === year && p.month === month);
        setIsClosed(Boolean(match?.is_closed));
      })
      .catch(() => setIsClosed(false))
      .finally(() => setLoading(false));
  }, [year, month]);

  return { isClosed, loading };
}
